export default "__VITE_ASSET__g7yTvGk7__"